import { render, staticRenderFns } from "./SceneBoxes.vue?vue&type=template&id=149a4cc4&"
import script from "./SceneBoxes.vue?vue&type=script&lang=js&"
export * from "./SceneBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports